import React from 'react'

import { useCookies } from 'react-cookie'

import CustomImage from 'components/custom-image/CustomImage'

import { RootState } from 'redux/reducers/rootReducer'

import Coin from 'assets/images/Coin.png'

import './Credits.scss'
import { useDispatch, useSelector } from 'react-redux'
import { SetAiPopupAction } from 'layouts/dashboard/store/actions'

const HeaderButtonRender = (): React.ReactElement => {
    const stepIndex = useSelector((state: RootState) => state.app.stepIndex)

    const dispatch = useDispatch()
    const cookies = useCookies(['credits', 'isTrialUsed'])[0]

    const handleClickAi = () => {
        dispatch(
            SetAiPopupAction({
                isOpen: true,
            }),
        )
    }

    const credits =
        cookies.credits && cookies.credits !== 'undefined' ? cookies.credits : 0
    return (
        <div
            className={`credits ${
                cookies.isTrialUsed === 'false' ? 'credits--trial' : ''
            } ${stepIndex === 3 ? 'fourth-step' : ''}`}
        >
            <button
                type='button'
                className='credits__ai-target'
                onClick={() => handleClickAi()}
            >
                <CustomImage src={Coin} className='credits__coin' />
                <span className='credits__amount'>{credits}</span>
            </button>
        </div>
    )
}

export default HeaderButtonRender
